// Editorial translations for Melilux. Use <gold>...</gold> for brushed-gold
// serif-italic emphasis. \n = line break.

export const LANGS = [
    { code: "ro", label: "RO" },
    { code: "ru", label: "RU" },
    { code: "en", label: "EN" },
];

const ABOUT_EN = {
    "about.overline": "Our story",
    "about.title": "Italian furniture, <gold>brought to Chișinău.</gold>",
    "about.intro.overline": "Established · MMXIII · 2013",
    "about.intro.title": "A family of\n<gold>Italian houses.</gold>",
    "about.intro.p1": "Melilux is the official importer and distributor in the Republic of Moldova for a curated portfolio of Italian furniture manufacturers — classical and modern.",
    "about.intro.p2": "Each Italian house we represent brings its own signature — a distinctive range of models, refined design, and materials selected to endure.",
    "about.intro.p3": "We strive to bring style, quality and elegance into your home.",
    "about.p1.title": "Authentic Italian houses",
    "about.p1.body": "We work directly with established Italian manufacturers — no intermediaries, no compromises. Every piece is produced in Italy.",
    "about.p2.title": "Two sensibilities",
    "about.p2.body": "Classical or modern — each of our brands offers a complete language. Mix freely, or stay true to one.",
    "about.p3.title": "Service that endures",
    "about.p3.body": "We accompany you from the first sketch to the final delivery — measuring, configuring, and installing in your Chișinău home.",
    "about.quote.overline": "Our promise",
    "about.quote.text": "Melilux — <gold>in harmony with your dream.</gold>",
    "about.quote.author": "— Melilux, since 2013",
    "about.visit.overline": "Visit us",
    "about.visit.title": "Book an appointment\n<gold>now.</gold>",
    "about.visit.lead": "Our Chișinău studio welcomes visitors privately. We look forward to your visit — unhurried, alongside us.",
    "about.visit.btn": "Request an appointment",
};

const ABOUT_RO = {
    "about.overline": "Povestea noastră",
    "about.title": "Mobilă italiană, <gold>adusă la Chișinău.</gold>",
    "about.intro.overline": "Activăm din 2013",
    "about.intro.title": "O familie de\n<gold>fabrici italiene.</gold>",
    "about.intro.p1": "Salonul de mobilă italiană 'Melilux' este importator și distribuitor în R. Moldova a mai multor branduri italiene de mobilier clasic și modern.",
    "about.intro.p2": "Fiecare fabrică în parte oferă o gamă de produse deosebite ca model și design.",
    "about.intro.p3": "Ne străduim să aducem în casele Dumneavoastră stil, calitate și eleganță.",
    "about.p1.title": "Fabrici italiene autentice",
    "about.p1.body": "Lucrăm direct cu producători italieni consacrați — fără intermediari, fără compromisuri. Fiecare piesă este produsă în Italia.",
    "about.p2.title": "Două sensibilități",
    "about.p2.body": "Clasic sau modern — fiecare dintre brandurile noastre oferă un limbaj complet. Amestecă liber sau rămâi fidel unuia.",
    "about.p3.title": "Servicii care durează",
    "about.p3.body": "Te însoțim de la prima schiță până la livrarea finală — măsurăm, configurăm și instalăm la tine acasă, în Chișinău.",
    "about.quote.overline": "Promisiunea noastră",
    "about.quote.text": "MELILUX — <gold>în armonie cu visul Tău.</gold>",
    "about.quote.author": "— Melilux, din 2013",
    "about.visit.overline": "Vizitează-ne",
    "about.visit.title": "Fă o programare\n<gold>acum.</gold>",
    "about.visit.lead": "Studioul nostru din Chișinău primește vizitatori în privat. Te așteptăm la o vizită, fără grabă, alături de noi.",
    "about.visit.btn": "Solicită o programare",
};

const ABOUT_RU = {
    "about.overline": "Наша история",
    "about.title": "Итальянская мебель, <gold>привезённая в Кишинёв.</gold>",
    "about.intro.overline": "Работаем с 2013 года",
    "about.intro.title": "Семья\n<gold>итальянских фабрик.</gold>",
    "about.intro.p1": "Салон итальянской мебели «Melilux» — официальный импортёр и дистрибьютор в Республике Молдова ведущих итальянских брендов классической и современной мебели.",
    "about.intro.p2": "Каждая фабрика, с которой мы сотрудничаем, предлагает уникальную палитру моделей и дизайна.",
    "about.intro.p3": "Мы стремимся принести в ваш дом стиль, качество и элегантность.",
    "about.p1.title": "Подлинные итальянские фабрики",
    "about.p1.body": "Мы работаем напрямую с известными итальянскими производителями — без посредников, без компромиссов. Каждое изделие произведено в Италии.",
    "about.p2.title": "Два направления",
    "about.p2.body": "Классика или модерн — каждый из наших брендов предлагает законченный язык. Смешивайте свободно или оставайтесь верны одному.",
    "about.p3.title": "Сервис, который остаётся",
    "about.p3.body": "Мы сопровождаем вас от первого эскиза до финальной доставки — замеры, конфигурация и установка в вашем доме в Кишинёве.",
    "about.quote.overline": "Наше обещание",
    "about.quote.text": "MELILUX — <gold>в гармонии с вашей мечтой.</gold>",
    "about.quote.author": "— Melilux, с 2013",
    "about.visit.overline": "Посетите нас",
    "about.visit.title": "Запишитесь на визит\n<gold>сейчас.</gold>",
    "about.visit.lead": "Наша кишинёвская студия принимает гостей в приватной обстановке. Ждём вас в гости — без спешки, вместе с нами.",
    "about.visit.btn": "Записаться на встречу",
};

const COMMON_EN = {
    // Browser-tab titles — rendered as "<value> — Melilux".
    "meta.title.home": "Italian Furniture in Chișinău",
    "meta.title.promo": "Offers",
    "meta.title.collections": "Collections",
    "meta.title.about": "About us",
    "meta.title.contact": "Contact",
    "meta.title.notFound": "Page not found",
    "meta.title.admin": "Admin",

    "nav.home": "Home",
    "nav.promo": "Offers",
    "nav.collections": "Collections",
    "nav.manifesto": "About",
    "nav.showroom": "Studio",
    "nav.inquire": "Inquire",

    "hero.overline": "Italian furniture · since 2013",
    "hero.title": "In harmony <gold>with your dream.</gold>",
    "hero.lead": "Melilux — official importer in Moldova of Italian classical and modern furniture. Curated for the discerning home.",
    "hero.exploreBtn": "Explore Collections",
    "hero.bookBtn": "Book a Viewing",
    "hero.established": "Since",
    "hero.location": "Chișinău · Moldova",

    "feat.overline": "Featured collections",
    "feat.title": "Three rooms,\n<gold>three sensibilities.</gold>",
    "feat.lead": "Pieces designed in conversation with the architecture of the home — soft volumes for living, ceremony for dining, quiet for rest.",
    "feat.card": "Collection",
    "feat.discover": "Discover",

    "exp.overline": "The Melilux experience",
    "exp.title": "Italian houses chosen\n<gold>to outlive trends.</gold>",
    "exp.lead": "We bring to Moldova a curated family of Italian manufacturers — classical and modern — each chosen for the quality of its materials and the integrity of its craft.",
    "exp.atelier": "Since 2013",
    "exp.pieces": "Italian houses",
    "exp.warranty": "Years of experience",

    "sel.overline": "Selected pieces",
    "sel.title": "A closer look.",
    "sel.viewAll": "View entire catalog →",

    "home.gallery.overline": "Completed projects",
    "home.gallery.title": "Interiors we <gold>brought to life.</gold>",
    "home.gallery.more": "Show more",

    "cta.overline": "Private appointments",
    "cta.title": "Experience the catalog <gold>in our studio.</gold>",
    "cta.button": "Book a private viewing",

    "footer.brand.overline": "Melilux",
    "footer.brand.title": "Italian furniture, <gold>in harmony with your dream.</gold>",
    "footer.brand.lead": "Official importer and distributor in the Republic of Moldova of Italian classical and modern furniture brands. Since 2013.",
    "footer.visit": "Visit",
    "footer.hours.weekdays": "Mon–Fri: 10:00–17:00",
    "footer.hours.saturday": "Sat: 10:00–14:00",
    "footer.closed": "Sun: closed",
    "footer.discover": "Discover",
    "footer.studio": "Studio",
    "footer.admin": "Admin",
    "footer.tagline": "In harmony with your dream",
    "footer.rights": "© {year} Melilux. All rights reserved.",

    "cat.overline": "The catalog",
    "cat.title": "Every piece, <gold>considered.</gold>",
    "cat.lead": "Browse the complete Melilux catalog — Italian classical and modern pieces, imported directly from the manufacturer.",
    "cat.search.placeholder": "Search by name, material or description…",
    "cat.search.submit": "Search",
    "cat.search.active": 'Showing results for "{q}"',
    "cat.all": "All",
    "cat.room": "Room",
    "cat.material": "Material",
    "cat.style": "Style",
    "cat.clear": "Clear filters",
    "cat.loading": "Loading catalog",
    "cat.show": "Show",
    "cat.of": "of",
    "cat.empty.title": "No pieces match this selection.",
    "cat.empty.lead": "Try removing a filter.",

    "promo.overline": "Current offers",
    "promo.title": "Selected pieces, <gold>special prices.</gold>",
    "promo.lead": "Italian pieces at reduced prices — available immediately, in limited quantities. Guaranteed quality.",
    "promo.empty.title": "No offers at the moment.",
    "promo.empty.lead": "Check back soon — new pieces join the offers regularly.",

    "admin.view.list": "List view",
    "admin.view.grid": "Grid view",

    "style.classic": "Classic",
    "style.modern": "Modern",

    "prod.back": "Back to catalog",
    "prod.limited": "Limited edition",
    "prod.dimensions": "Dimensions",
    "prod.materials": "Materials",
    "prod.care": "Care",
    "prod.room": "Room",
    "prod.price": "Price",
    "prod.loading": "Loading piece…",
    "prod.notFound.title": "This piece could not be found.",
    "prod.notFound.lead": "It may have been removed, or the link is no longer valid.",
    "prod.inquire.overline": "Inquire about this piece",
    "prod.inquire.title": "Begin a <gold>conversation.</gold>",
    "prod.inquire.name": "Full name",
    "prod.inquire.email": "Email address",
    "prod.inquire.phone": "Phone",
    "prod.inquire.message": "Tell us about your space, finish preferences, intended room…",
    "prod.inquire.submit": "Send Inquiry",
    "prod.inquire.sending": "Sending…",
    "prod.inquire.fillRequired": "Please fill in your name, email and message.",
    "prod.inquire.success": "Inquiry sent. We will be in touch shortly.",
    "prod.inquire.error": "Could not send. Try again.",
    "prod.related.overline": "You may also consider",
    "prod.related.title": "From the same collection.",
    "prod.zoomHint": "Click photo to enlarge",
    "prod.inquire.nameRequired": "Name must be at least 2 characters.",
    "prod.inquire.phoneInvalid": "Please enter a valid phone number.",
    "prod.inquire.emailInvalid": "Please enter a valid email address.",
    "prod.inquire.messageRequired": "Message must be at least 5 characters.",


    "contact.overline": "Studio & inquiries",
    "contact.title": "Begin the <gold>conversation.</gold>",
    "contact.showroomLabel": "Chișinău studio",
    "contact.hoursLabel": "Opening hours",
    "contact.hoursBody": "Mon — Fri: 10:00 — 17:00\nSat: 10:00 — 14:00",
    "contact.closed": "Sun: closed",
    "contact.lineLabel": "Direct line",
    "contact.onlineLabel": "Online",
    "contact.pressLabel": "Press & trade",
    "contact.pressBody": "For interior designers, press inquiries or collaboration proposals, please email",
    "contact.form.overline": "Request",
    "contact.form.title": "Tell us what you are dreaming of.",
    "contact.form.kind.showroom": "Studio Visit",
    "contact.form.kind.general": "Design Question",
    "contact.form.kind.product": "Trade Inquiry",
    "contact.form.name": "Name",
    "contact.form.email": "Email address",
    "contact.form.phone": "Phone",
    "contact.form.message": "Tell us about your project, your space, or the date you would like to visit…",
    "contact.form.submit": "Send request",
    "contact.form.sending": "Sending…",
    "contact.form.fillRequired": "Please complete the required fields.",
    "contact.form.success": "Thank you. We will respond within 1 hour.",
    "contact.form.error": "Could not send.",
    "contact.mapLabel": "Find us",

    "nf.code": "404",
    "nf.title": "A piece <gold>misplaced.</gold>",
    "nf.lead": "The page you were looking for cannot be found. Return to the catalog or read our story.",
    "nf.home": "Return Home",
    "nf.coll": "View Collections",
};

const COMMON_RO = {
    // Titluri pentru tab-ul browserului — afișate ca "<valoare> — Melilux".
    "meta.title.home": "Mobilă italiană la Chișinău",
    "meta.title.promo": "Oferte",
    "meta.title.collections": "Colecții",
    "meta.title.about": "Despre noi",
    "meta.title.contact": "Contact",
    "meta.title.notFound": "Pagina nu a fost găsită",
    "meta.title.admin": "Administrare",

    "nav.home": "Acasă",
    "nav.promo": "Oferte",
    "nav.collections": "Colecții",
    "nav.manifesto": "Despre",
    "nav.showroom": "Studio",
    "nav.inquire": "Contact",

    "hero.overline": "Mobilă italiană · din 2013",
    "hero.title": "În armonie <gold>cu visul Tău.</gold>",
    "hero.lead": "Melilux — importator oficial în R. Moldova de mobilier italian clasic și modern. Curat pentru casele care apreciază detaliul.",
    "hero.exploreBtn": "Explorează colecțiile",
    "hero.bookBtn": "Rezervă o vizită",
    "hero.established": "Din",
    "hero.location": "Chișinău · Moldova",

    "feat.overline": "Colecții recomandate",
    "feat.title": "Trei camere,\n<gold>trei sensibilități.</gold>",
    "feat.lead": "Piese gândite în dialog cu arhitectura casei — volume calde pentru living, ceremonie pentru sufragerie, liniște pentru odihnă.",
    "feat.card": "Colecția",
    "feat.discover": "Descoperă",

    "exp.overline": "Experiența Melilux",
    "exp.title": "Fabrici italiene alese\n<gold>să depășească modele.</gold>",
    "exp.lead": "Aducem în Moldova o familie selectată de producători italieni — clasici și moderni — fiecare ales pentru calitatea materialelor și integritatea măiestriei.",
    "exp.atelier": "Din 2013",
    "exp.pieces": "Fabrici italiene",
    "exp.warranty": "Ani de experiență",

    "sel.overline": "Piese alese",
    "sel.title": "O privire mai atentă.",
    "sel.viewAll": "Vezi întregul catalog →",

    "home.gallery.overline": "Proiecte realizate",
    "home.gallery.title": "Interioare pe care <gold>le-am adus la viață.</gold>",
    "home.gallery.more": "Vezi mai mult",

    "cta.overline": "Întâlniri private",
    "cta.title": "Descoperă catalogul <gold>în studioul nostru.</gold>",
    "cta.button": "Rezervă o vizită privată",

    "footer.brand.overline": "Melilux",
    "footer.brand.title": "Mobilă italiană, <gold>în armonie cu visul Tău.</gold>",
    "footer.brand.lead": "Importator și distribuitor oficial în R. Moldova al brandurilor italiene de mobilier clasic și modern. Din 2013.",
    "footer.visit": "Vizitează",
    "footer.hours.weekdays": "Luni–Vineri: 10:00–17:00",
    "footer.hours.saturday": "Sâmbătă: 10:00–14:00",
    "footer.closed": "Duminică: închis",
    "footer.discover": "Descoperă",
    "footer.studio": "Studio",
    "footer.admin": "Admin",
    "footer.tagline": "În armonie cu visul Tău",
    "footer.rights": "© {year} Melilux. Toate drepturile rezervate.",

    "cat.overline": "Catalogul",
    "cat.title": "Fiecare piesă, <gold>gândită atent.</gold>",
    "cat.lead": "Răsfoiește întregul catalog Melilux — piese italiene clasice și moderne, importate direct de la producător.",
    "cat.search.placeholder": "Caută după nume, material sau descriere…",
    "cat.search.submit": "Caută",
    "cat.search.active": 'Rezultate pentru "{q}"',
    "cat.all": "Toate",
    "cat.room": "Cameră",
    "cat.material": "Material",
    "cat.style": "Stil",
    "cat.clear": "Șterge filtrele",
    "cat.loading": "Se încarcă catalogul",
    "cat.show": "Arată",
    "cat.of": "din",
    "cat.empty.title": "Nicio piesă nu corespunde acestei selecții.",
    "cat.empty.lead": "Încearcă să elimini un filtru.",

    "promo.overline": "Oferte curente",
    "promo.title": "Piese alese, <gold>prețuri speciale.</gold>",
    "promo.lead": "Piese italiene la prețuri reduse — disponibile imediat, în cantități limitate. Calitate garantată.",
    "promo.empty.title": "Momentan nu există oferte.",
    "promo.empty.lead": "Revino în curând — adăugăm piese noi în mod regulat.",

    "admin.view.list": "Vizualizare listă",
    "admin.view.grid": "Vizualizare grilă",

    "style.classic": "Clasic",
    "style.modern": "Modern",

    "prod.back": "Înapoi la catalog",
    "prod.limited": "Ediție limitată",
    "prod.dimensions": "Dimensiuni",
    "prod.materials": "Materiale",
    "prod.care": "Întreținere",
    "prod.room": "Cameră",
    "prod.price": "Preț",
    "prod.loading": "Se încarcă piesa…",
    "prod.notFound.title": "Această piesă nu a fost găsită.",
    "prod.notFound.lead": "Este posibil să fi fost eliminată sau linkul nu mai este valid.",
    "prod.inquire.overline": "Solicită informații despre această piesă",
    "prod.inquire.title": "Începe o <gold>conversație.</gold>",
    "prod.inquire.name": "Nume",
    "prod.inquire.email": "Adresă de email",
    "prod.inquire.phone": "Telefon",
    "prod.inquire.message": "Spune-ne despre spațiul tău, preferințele de finisaj, camera vizată…",
    "prod.inquire.submit": "Trimite cererea",
    "prod.inquire.sending": "Se trimite…",
    "prod.inquire.fillRequired": "Te rugăm completează numele, emailul și mesajul.",
    "prod.inquire.success": "Cerere trimisă. Vom reveni în curând.",
    "prod.inquire.error": "Nu am putut trimite. Încearcă din nou.",
    "prod.related.overline": "Ai putea aprecia și",
    "prod.related.title": "Din aceeași colecție.",
    "prod.zoomHint": "Apasă pe imagine pentru a o mări",
    "prod.inquire.nameRequired": "Numele trebuie să aibă minim 2 caractere.",
    "prod.inquire.phoneInvalid": "Te rugăm introdu un număr de telefon valid.",
    "prod.inquire.emailInvalid": "Te rugăm introdu o adresă de email validă.",
    "prod.inquire.messageRequired": "Mesajul trebuie să aibă minim 5 caractere.",

    "contact.overline": "Studio și solicitări",
    "contact.title": "Începe o <gold>conversație.</gold>",
    "contact.showroomLabel": "Studio Chișinău",
    "contact.hoursLabel": "Program",
    "contact.hoursBody": "Luni — Vineri: 10:00 — 17:00\nSâmbătă: 10:00 — 14:00",
    "contact.closed": "Duminică: închis",
    "contact.lineLabel": "Linie directă",
    "contact.onlineLabel": "Online",
    "contact.pressLabel": "Presă și comerț",
    "contact.pressBody": "Pentru designeri de interior, presă sau propuneri de colaborare, scrie la",
    "contact.form.overline": "Solicitare",
    "contact.form.title": "Spune-ne ce visezi.",
    "contact.form.kind.showroom": "Vizită la studio",
    "contact.form.kind.general": "Întrebare design",
    "contact.form.kind.product": "Solicitare comercială",
    "contact.form.name": "Nume",
    "contact.form.email": "Adresă de email",
    "contact.form.phone": "Telefon",
    "contact.form.message": "Spune-ne despre proiectul tău, despre spațiu sau despre data la care ai vrea să vizitezi…",
    "contact.form.submit": "Trimite solicitarea",
    "contact.form.sending": "Se trimite…",
    "contact.form.fillRequired": "Te rugăm completează câmpurile obligatorii.",
    "contact.form.success": "Mulțumim. Vom răspunde în decurs de o oră.",
    "contact.form.error": "Nu am putut trimite.",
    "contact.mapLabel": "Găsește-ne",

    "nf.code": "404",
    "nf.title": "O piesă <gold>rătăcită.</gold>",
    "nf.lead": "Pagina pe care o căutai nu poate fi găsită. Întoarce-te la catalog sau citește povestea noastră.",
    "nf.home": "Înapoi acasă",
    "nf.coll": "Vezi colecțiile",
};

const COMMON_RU = {
    // Заголовки вкладки браузера — показываются как «<значение> — Melilux».
    "meta.title.home": "Итальянская мебель в Кишинёве",
    "meta.title.promo": "Акции",
    "meta.title.collections": "Коллекции",
    "meta.title.about": "О нас",
    "meta.title.contact": "Контакты",
    "meta.title.notFound": "Страница не найдена",
    "meta.title.admin": "Администрирование",

    "nav.home": "Главная",
    "nav.promo": "Акции",
    "nav.collections": "Коллекции",
    "nav.manifesto": "О нас",
    "nav.showroom": "Студия",
    "nav.inquire": "Связаться",

    "hero.overline": "Итальянская мебель · с 2013",
    "hero.title": "В гармонии <gold>с вашей мечтой.</gold>",
    "hero.lead": "Melilux — официальный импортёр в Молдове итальянской классической и современной мебели. Подобрано для тех, кто ценит детали.",
    "hero.exploreBtn": "Открыть коллекции",
    "hero.bookBtn": "Записаться на просмотр",
    "hero.established": "С",
    "hero.location": "Кишинёв · Молдова",

    "feat.overline": "Избранные коллекции",
    "feat.title": "Три комнаты,\n<gold>три характера.</gold>",
    "feat.lead": "Предметы, созданные в диалоге с архитектурой дома — мягкие объёмы для гостиной, церемония для столовой, тишина для отдыха.",
    "feat.card": "Коллекция",
    "feat.discover": "Открыть",

    "exp.overline": "Опыт Melilux",
    "exp.title": "Итальянские фабрики, выбранные\n<gold>пережить тенденции.</gold>",
    "exp.lead": "Мы привозим в Молдову семью отобранных итальянских производителей — классических и современных — выбранных за качество материалов и цельность ремесла.",
    "exp.atelier": "С 2013 года",
    "exp.pieces": "Итальянских фабрик",
    "exp.warranty": "Лет опыта",

    "sel.overline": "Избранные изделия",
    "sel.title": "Ближе.",
    "sel.viewAll": "Открыть весь каталог →",

    "home.gallery.overline": "Реализованные проекты",
    "home.gallery.title": "Интерьеры, которые <gold>мы воплотили.</gold>",
    "home.gallery.more": "Показать ещё",

    "cta.overline": "Частные встречи",
    "cta.title": "Откройте каталог <gold>в нашей студии.</gold>",
    "cta.button": "Записаться на частный просмотр",

    "footer.brand.overline": "Melilux",
    "footer.brand.title": "Итальянская мебель, <gold>в гармонии с вашей мечтой.</gold>",
    "footer.brand.lead": "Официальный импортёр и дистрибьютор в Республике Молдова итальянских брендов классической и современной мебели. С 2013 года.",
    "footer.visit": "Посетить",
    "footer.hours.weekdays": "Пн–Пт: 10:00–17:00",
    "footer.hours.saturday": "Сб: 10:00–14:00",
    "footer.closed": "Вс: выходной",
    "footer.discover": "Открыть",
    "footer.studio": "Студия",
    "footer.admin": "Админ",
    "footer.tagline": "В гармонии с вашей мечтой",
    "footer.rights": "© {year} Melilux. Все права защищены.",

    "cat.overline": "Каталог",
    "cat.title": "Каждый предмет — <gold>с вниманием.</gold>",
    "cat.lead": "Полный каталог Melilux — итальянские предметы классического и современного дизайна, импортированные напрямую от производителя.",
    "cat.search.placeholder": "Поиск по названию, материалу или описанию…",
    "cat.search.submit": "Найти",
    "cat.search.active": 'Результаты для "{q}"',
    "cat.all": "Все",
    "cat.room": "Комната",
    "cat.material": "Материал",
    "cat.style": "Стиль",
    "cat.clear": "Сбросить фильтры",
    "cat.loading": "Загрузка каталога",
    "cat.show": "Показать",
    "cat.of": "из",
    "cat.empty.title": "Нет предметов, соответствующих фильтрам.",
    "cat.empty.lead": "Попробуйте убрать один из фильтров.",

    "promo.overline": "Текущие предложения",
    "promo.title": "Избранные предметы — <gold>особые цены.</gold>",
    "promo.lead": "Итальянские предметы по сниженным ценам — в наличии, в ограниченном количестве. Гарантированное качество.",
    "promo.empty.title": "Сейчас предложений нет.",
    "promo.empty.lead": "Загляните позже — мы регулярно добавляем новые предметы.",

    "admin.view.list": "Список",
    "admin.view.grid": "Сетка",

    "style.classic": "Классика",
    "style.modern": "Модерн",

    "prod.back": "Назад в каталог",
    "prod.limited": "Ограниченная серия",
    "prod.dimensions": "Размеры",
    "prod.materials": "Материалы",
    "prod.care": "Уход",
    "prod.room": "Комната",
    "prod.price": "Цена",
    "prod.loading": "Загружается…",
    "prod.notFound.title": "Это изделие не найдено.",
    "prod.notFound.lead": "Возможно, оно было удалено или ссылка больше не действительна.",
    "prod.inquire.overline": "Запросить информацию об этом изделии",
    "prod.inquire.title": "Начните <gold>разговор.</gold>",
    "prod.inquire.name": "Полное имя",
    "prod.inquire.email": "Email",
    "prod.inquire.phone": "Телефон",
    "prod.inquire.message": "Расскажите о вашем пространстве, предпочтениях по отделке, комнате…",
    "prod.inquire.submit": "Отправить запрос",
    "prod.inquire.sending": "Отправка…",
    "prod.inquire.fillRequired": "Пожалуйста, заполните имя, email и сообщение.",
    "prod.inquire.success": "Запрос отправлен. Мы свяжемся с вами в ближайшее время.",
    "prod.inquire.error": "Не удалось отправить. Попробуйте снова.",
    "prod.related.overline": "Вам также может понравиться",
    "prod.related.title": "Из той же коллекции.",
    "prod.zoomHint": "Нажмите на фото, чтобы увеличить",
    "prod.inquire.nameRequired": "Имя должно содержать минимум 2 символа.",
    "prod.inquire.phoneInvalid": "Пожалуйста, введите корректный номер телефона.",
    "prod.inquire.emailInvalid": "Пожалуйста, введите корректный email.",
    "prod.inquire.messageRequired": "Сообщение должно содержать минимум 5 символов.",

    "contact.overline": "Студия и обращения",
    "contact.title": "Начните <gold>разговор.</gold>",
    "contact.showroomLabel": "Кишинёвская студия",
    "contact.hoursLabel": "Время работы",
    "contact.hoursBody": "Пн — Пт: 10:00 — 17:00\nСб: 10:00 — 14:00",
    "contact.closed": "Вс: выходной",
    "contact.lineLabel": "Прямая линия",
    "contact.onlineLabel": "Онлайн",
    "contact.pressLabel": "Пресса и партнёры",
    "contact.pressBody": "Для дизайнеров интерьера, прессы или предложений о сотрудничестве пишите на",
    "contact.form.overline": "Запрос",
    "contact.form.title": "Расскажите, о чём вы мечтаете.",
    "contact.form.kind.showroom": "Визит в студию",
    "contact.form.kind.general": "Вопрос по дизайну",
    "contact.form.kind.product": "Партнёрский запрос",
    "contact.form.name": "Имя",
    "contact.form.email": "Email",
    "contact.form.phone": "Телефон",
    "contact.form.message": "Расскажите о вашем проекте, пространстве или дате, когда вы хотели бы посетить…",
    "contact.form.submit": "Отправить запрос",
    "contact.form.sending": "Отправка…",
    "contact.form.fillRequired": "Пожалуйста, заполните обязательные поля.",
    "contact.form.success": "Спасибо. Мы ответим в течение часа.",
    "contact.form.error": "Не удалось отправить.",
    "contact.mapLabel": "Найти нас",

    "nf.code": "404",
    "nf.title": "Предмет <gold>потерян.</gold>",
    "nf.lead": "Страница, которую вы искали, не найдена. Вернитесь в каталог или прочтите нашу историю.",
    "nf.home": "На главную",
    "nf.coll": "Открыть коллекции",
};

const ADMIN_EN = {
    "admin.cat.title": "Manage collections",
    "admin.cat.overline": "Collections",
    "admin.cat.new": "New collection",
    "admin.cat.col.collection": "Collection",
    "admin.cat.col.slug": "Slug",
    "admin.cat.col.products": "Products",
    "admin.cat.col.description": "Description",
    "admin.cat.col.nav": "Nav",
    "admin.cat.col.actions": "Actions",
    "admin.delete.tip": "Delete",
    "admin.delete.again": "Click again to confirm",
    "admin.trash.title": "Trash",
    "admin.trash.overline": "Recently deleted",
    "admin.trash.hint": "Items here are automatically deleted after {days} days.",
    "admin.trash.empty": "Trash is empty.",
    "admin.trash.loading": "Loading…",
    "admin.trash.products": "Products",
    "admin.trash.categories": "Collections",
    "admin.trash.restore": "Restore",
    "admin.trash.deleteNow": "Delete permanently",
    "admin.trash.daysLeft": "{n} days left",
    "admin.trash.expiresToday": "Expires today",
    "admin.trash.restored": "Restored",
    "admin.trash.purged": "Permanently deleted",
    "admin.trash.moved": "Moved to trash",
    "admin.cat.empty": "No collections yet.",
    "admin.cat.modal.new.overline": "New collection",
    "admin.cat.modal.new.title": "Define a new room.",
    "admin.cat.modal.edit.overline": "Edit collection",
    "admin.cat.modal.edit.title": "Refine the details.",
    "admin.cat.field.name": "Name",
    "admin.cat.field.slug": "Slug (auto-generated)",
    "admin.cat.field.parent": "Parent collection (optional)",
    "admin.cat.field.parent.none": "— None (top level) —",
    "admin.cat.field.description": "Description",
    "admin.cat.field.cover": "Cover image",
    "admin.cat.field.cover.upload": "Upload image",
    "admin.cat.field.cover.uploading": "Uploading…",
    "admin.cat.field.cover.url": "…or paste URL",
    "admin.cat.field.cover.fromProducts": "Choose from products",
    "admin.cat.picker.title": "Pick an image from a product",
    "admin.cat.picker.use": "Use this photo",
    "admin.cat.picker.step.collection": "Collections",
    "admin.cat.picker.searchCollections": "Search collections…",
    "admin.cat.picker.noProducts": "No products with images in this collection.",
    "admin.cat.picker.search": "Search products…",
    "admin.cat.picker.empty": "No product images available.",
    "admin.cat.picker.loading": "Loading…",
    "admin.cat.field.nav": "Show in navigation",
    "admin.cat.field.nav.label": "Show this collection in the public navigation",
    "admin.cat.cancel": "Cancel",
    "admin.cat.save": "Save changes",
    "admin.cat.create": "Create",
    "admin.cat.saving": "Saving…",
    "admin.cat.delete.confirm": "Delete \"{name}\"? This cannot be undone.",
    "admin.cat.field.highlighted": "Highlight",
    "admin.cat.field.highlighted.label": "Show as highlighted in the filter bar",
    "admin.cat.col.highlighted": "Highlight",
    "admin.nav.console": "Atelier console",
    "admin.nav.overview": "Overview",
    "admin.nav.homepage": "Homepage",
    "admin.nav.categories": "Categories",
    "admin.nav.products": "Products",
    "admin.nav.inquiries": "Inquiries",
    "admin.nav.trash": "Trash",
    "admin.nav.viewSite": "View site",
    "admin.nav.darkMode": "Dark mode",
    "admin.nav.lightMode": "Light mode",
    "admin.nav.language": "Language",
    "admin.nav.signedIn": "Signed in",
    "admin.nav.signOut": "Sign out",

    "admin.home.leave.body": "You have unsaved changes on the homepage. What would you like to do?",
    "admin.home.leave.saveGo": "Save and leave",
    "admin.home.leave.discard": "Leave without saving",
    "admin.home.leave.stay": "Stay on this page",

    "admin.home.overline": "Homepage",
    "admin.home.title": "Homepage curation",
    "admin.home.featured.title": "Selected pieces",
    "admin.home.featured.hint": "Choose a collection, then pick up to 3 of its products for the \"Selected pieces\" section. Click order = display order. If none are picked, the newest featured products are shown automatically.",
    "admin.home.featured.empty": "No products selected — the homepage falls back to products marked as featured.",
    "admin.home.featured.max": "Maximum 3 products.",
    "admin.home.gallery.title": "Completed projects gallery",
    "admin.home.gallery.hint": "Pick a collection, then choose which of its products appear in the \"Completed projects\" gallery on the homepage. Photos link to the product page. Click order = display order.",
    "admin.home.gallery.category": "Source collection",
    "admin.home.gallery.pickCategory": "Choose a collection…",
    "admin.home.gallery.empty": "No products selected — the gallery section is hidden on the homepage.",
    "admin.home.gallery.noProducts": "This collection has no products.",
    "admin.home.gallery.selectAll": "Select all",
    "admin.home.gallery.clear": "Clear selection",
    "admin.home.gallery.selected": "{n} selected",
    "admin.home.gallery.max": "Maximum {n} products in the gallery.",
    "admin.home.save": "Save homepage",
    "admin.home.saving": "Saving…",
    "admin.home.saved": "Homepage saved",
    "admin.home.undo": "Undo changes",
    "admin.home.unsaved": "Unsaved changes",
    "admin.home.open": "Open homepage",
    "admin.home.tagline.title": "Text on the hero photo",
    "admin.home.tagline.hint": "Shown over the photo at the top of the homepage. One field per site language — an empty RU or EN field falls back to the Romanian text; clear all three to hide it.",
    "admin.home.images.title": "Homepage images",
    "admin.home.images.hint": "Override the main homepage images. When empty, the defaults are used. The three collection-card images come from each collection's cover — edit those in the Categories tab.",
    "admin.home.images.hero": "Hero image (top of the page)",
    "admin.home.images.experience": "\"Melilux experience\" section image",
    "admin.home.images.upload": "Upload image",
    "admin.home.images.uploading": "Uploading…",
    "admin.home.images.remove": "Remove",
    "admin.home.images.fromProduct": "Choose from products",
    "admin.home.images.pickProduct": "Choose a product…",
    "admin.home.images.pickPhoto": "Click a photo to use it",
    "admin.home.images.noImages": "This product has no photos.",
    "admin.about.images.title": "About page images",
    "admin.about.images.hint": "The two photos on the \"About\" page. When empty, the defaults are used.",
    "admin.about.images.intro": "\"A family of Italian houses\" section image",
    "admin.about.images.visit": "\"By appointment\" section image",

    "admin.prod.title": "Manage pieces",
    "admin.prod.overline": "Catalog",
    "admin.prod.new": "New piece",
    "admin.prod.search": "Search by name or description…",
    "admin.prod.filter.collections": "All collections",
    "admin.prod.filter.styles": "All styles",
    "admin.prod.filter.statuses": "All statuses",
    "admin.prod.filter.clear": "Clear all",
    "admin.prod.col.piece": "Piece",
    "admin.prod.col.collection": "Collection",
    "admin.prod.col.style": "Style",
    "admin.prod.col.price": "Price",
    "admin.prod.col.status": "Status",
    "admin.prod.col.featured": "Featured",
    "admin.prod.col.views": "Views",
    "admin.prod.col.actions": "Actions",
    "admin.prod.empty": "No pieces.",
    "admin.prod.onRequest": "on request",
    "admin.prod.perPage": "Per page",
    "admin.prod.modal.new.overline": "New piece",
    "admin.prod.modal.new.title": "Add to the catalog.",
    "admin.prod.modal.edit.overline": "Edit piece",
    "admin.prod.modal.edit.title": "Update the details.",
    "admin.prod.field.name": "Name",
    "admin.prod.field.description": "Description",
    "admin.prod.field.collection": "Collection",
    "admin.prod.field.collection.placeholder": "Select a collection",
    "admin.prod.field.collections": "Collections",
    "admin.prod.field.collections.hint": "Select one or more — the first one is the primary collection.",
    "admin.prod.field.collections.primary": "Primary",
    "admin.prod.field.status": "Status",
    "admin.prod.field.style": "Style",
    "admin.prod.field.style.none": "— None —",
    "admin.prod.field.price": "Price (optional)",
    "admin.prod.field.salePrice": "Sale price (optional)",
    "admin.prod.field.salePercent": "Discount % (optional)",
    "admin.prod.field.room": "Room (optional)",
    "admin.prod.field.dimensions": "Dimensions (optional)",
    "admin.prod.field.materials": "Materials (optional)",
    "admin.prod.field.materials.placeholder": "Add a material and press Enter",
    "admin.prod.field.materials.add": "Add",
    "admin.prod.field.care": "Care instructions (optional)",
    "admin.prod.field.images": "Images",
    "admin.prod.field.images.upload": "Upload images",
    "admin.prod.field.images.uploading": "Uploading…",
    "admin.prod.field.images.hint": "Uploaded as-is. These full photos are what the product page shows.",
    "admin.prod.field.card": "Collection card image",
    "admin.prod.field.card.hint": "The 3:4 thumbnail used in listings (Collections, homepage). Hover a photo above and choose \"Crop for card\". The product page always shows the full photo.",
    "admin.prod.field.card.use": "Crop for card",
    "admin.prod.field.card.cropTitle": "Frame the collection card.",
    "admin.prod.field.card.custom": "Custom crop",
    "admin.prod.field.card.auto": "Automatic — first photo, centre-cropped",
    "admin.prod.field.card.reset": "Back to automatic",
    "admin.prod.field.card.saved": "Card image updated — remember to save",
    "admin.prod.field.featured": "Featured on homepage",
    "admin.prod.field.featured.label": "Show this piece on the homepage",
    "admin.prod.field.visible": "Visible in collections",
    "admin.prod.field.visible.label": "Show this piece in the public collections page",
    "admin.prod.cancel": "Cancel",
    "admin.prod.save": "Save changes",
    "admin.prod.create": "Create piece",
    "admin.prod.saving": "Saving…",
    "admin.prod.delete.confirm": "Delete \"{name}\"?",
    "admin.prod.field.currency": "Currency",
    "admin.inq.title": "Inquiries",
    "admin.inq.overline": "Correspondence",
    "admin.inq.filter.all": "All",
    "admin.inq.filter.unread": "Unread",
    "admin.inq.filter.product": "Product",
    "admin.inq.filter.showroom": "Studio",
    "admin.inq.filter.general": "General",
    "admin.inq.empty": "No inquiries match.",
    "admin.inq.select.overline": "Select",
    "admin.inq.select.title": "Choose an inquiry to read.",
    "admin.inq.kind.showroom": "Studio visit",
    "admin.inq.kind.general": "Design question",
    "admin.inq.kind.product": "Product inquiry",
    "admin.inq.mail": "Mail",
    "admin.inq.phone": "Phone",
    "admin.inq.message": "Message",
    "admin.inq.reply": "Reply by email",
    "admin.inq.delete": "Delete",
    "admin.inq.delete.confirm": "Delete this inquiry?",
    "admin.inq.received": "Received",
    "admin.overview": "Atelier overview",
    "admin.greeting": "Good day,",
    "admin.curator": "curator.",
    "admin.kpi.pieces": "Pieces in catalog",
    "admin.kpi.collections": "Collections",
    "admin.kpi.inquiries": "Inquiries",
    "admin.kpi.visitors": "Visitors",
    "admin.kpi.unread": "Unread",
    "admin.chart.byCollection": "Catalog by collection",
    "admin.chart.trend": "Inquiries · last 7 days",
    "admin.chart.topViewed": "Most viewed pieces",
    "admin.range.7d": "7 days",
    "admin.range.30d": "30 days",
    "admin.range.all": "Lifetime",
    "admin.chart.availability": "Availability mix",
    "admin.activity": "Recent activity",
    "admin.noData": "No data yet",
    "admin.noActivity": "No activity yet.",
    "admin.time.justNow": "just now",
    "admin.time.mAgo": "m ago",
    "admin.time.hAgo": "h ago",
};

const ADMIN_RO = {
    // Categories
    "admin.cat.title": "Gestionează colecțiile",
    "admin.cat.overline": "Colecții",
    "admin.cat.new": "Colecție nouă",
    "admin.cat.col.collection": "Colecție",
    "admin.cat.col.slug": "Slug",
    "admin.cat.col.products": "Produse",
    "admin.cat.col.description": "Descriere",
    "admin.cat.col.nav": "Nav",
    "admin.cat.col.actions": "Acțiuni",
    "admin.delete.tip": "Șterge",
    "admin.delete.again": "Apăsați din nou pentru a confirma",
    "admin.trash.title": "Coș de gunoi",
    "admin.trash.overline": "Șterse recent",
    "admin.trash.hint": "Elementele de aici sunt șterse automat după {days} zile.",
    "admin.trash.empty": "Coșul este gol.",
    "admin.trash.loading": "Se încarcă…",
    "admin.trash.products": "Produse",
    "admin.trash.categories": "Colecții",
    "admin.trash.restore": "Restaurează",
    "admin.trash.deleteNow": "Șterge definitiv",
    "admin.trash.daysLeft": "{n} zile rămase",
    "admin.trash.expiresToday": "Expiră azi",
    "admin.trash.restored": "Restaurat",
    "admin.trash.purged": "Șters definitiv",
    "admin.trash.moved": "Mutat în coș",
    "admin.cat.empty": "Nicio colecție încă.",
    "admin.cat.modal.new.overline": "Colecție nouă",
    "admin.cat.modal.new.title": "Definește o cameră nouă.",
    "admin.cat.modal.edit.overline": "Editează colecția",
    "admin.cat.modal.edit.title": "Rafinează detaliile.",
    "admin.cat.field.name": "Nume",
    "admin.cat.field.slug": "Slug (auto-generat)",
    "admin.cat.field.parent": "Colecție părinte (opțional)",
    "admin.cat.field.parent.none": "— Niciuna (nivel principal) —",
    "admin.cat.field.description": "Descriere",
    "admin.cat.field.cover": "Imagine copertă",
    "admin.cat.field.cover.upload": "Încarcă imagine",
    "admin.cat.field.cover.uploading": "Se încarcă…",
    "admin.cat.field.cover.url": "…sau inserează URL",
    "admin.cat.field.cover.fromProducts": "Alege dintr-un produs",
    "admin.cat.picker.title": "Alegeți o imagine dintr-un produs",
    "admin.cat.picker.use": "Folosește fotografia",
    "admin.cat.picker.step.collection": "Colecții",
    "admin.cat.picker.searchCollections": "Caută colecții…",
    "admin.cat.picker.noProducts": "Niciun produs cu imagini în această colecție.",
    "admin.cat.picker.search": "Caută produse…",
    "admin.cat.picker.empty": "Nicio imagine disponibilă.",
    "admin.cat.picker.loading": "Se încarcă…",
    "admin.cat.field.nav": "Afișează în navigație",
    "admin.cat.field.nav.label": "Afișează această colecție în navigația publică",
    "admin.cat.cancel": "Anulează",
    "admin.cat.save": "Salvează modificările",
    "admin.cat.create": "Creează",
    "admin.cat.saving": "Se salvează…",
    "admin.cat.delete.confirm": "Șterge \"{name}\"? Această acțiune este ireversibilă.",
    "admin.cat.field.highlighted": "Evidențiere",
    "admin.cat.field.highlighted.label": "Afișează cu evidențiere în bara de filtre",
    "admin.cat.col.highlighted": "Evidențiat",
    // Products
    "admin.nav.console": "Consolă atelier",
    "admin.nav.overview": "Panou general",
    "admin.nav.homepage": "Homepage",
    "admin.nav.categories": "Categorii",
    "admin.nav.products": "Produse",
    "admin.nav.inquiries": "Solicitări",
    "admin.nav.trash": "Coș de gunoi",
    "admin.nav.viewSite": "Vezi site-ul",
    "admin.nav.darkMode": "Mod întunecat",
    "admin.nav.lightMode": "Mod luminos",
    "admin.nav.language": "Limbă",
    "admin.nav.signedIn": "Autentificat",
    "admin.nav.signOut": "Deconectare",

    "admin.home.leave.body": "Ai modificări nesalvate pe homepage. Ce dorești să faci?",
    "admin.home.leave.saveGo": "Salvează și pleacă",
    "admin.home.leave.discard": "Pleacă fără salvare",
    "admin.home.leave.stay": "Rămâi pe pagină",

    "admin.home.overline": "Homepage",
    "admin.home.title": "Curare homepage",
    "admin.home.featured.title": "Piese alese",
    "admin.home.featured.hint": "Alege o colecție, apoi până la 3 produse pentru secțiunea \"Piese alese\". Ordinea de click = ordinea de afișare. Dacă nu alegi nimic, se afișează automat cele mai noi produse marcate ca featured.",
    "admin.home.featured.empty": "Niciun produs selectat — homepage-ul revine la produsele marcate ca featured.",
    "admin.home.featured.max": "Maxim 3 produse.",
    "admin.home.gallery.title": "Galerie proiecte realizate",
    "admin.home.gallery.hint": "Alege o colecție, apoi produsele care apar în galeria \"Proiecte realizate\" de pe homepage. Fotografiile duc la pagina produsului. Ordinea de click = ordinea de afișare.",
    "admin.home.gallery.category": "Colecția sursă",
    "admin.home.gallery.pickCategory": "Alege o colecție…",
    "admin.home.gallery.empty": "Niciun produs selectat — secțiunea de galerie este ascunsă pe homepage.",
    "admin.home.gallery.noProducts": "Această colecție nu are produse.",
    "admin.home.gallery.selectAll": "Selectează tot",
    "admin.home.gallery.clear": "Golește selecția",
    "admin.home.gallery.selected": "{n} selectate",
    "admin.home.gallery.max": "Maxim {n} produse în galerie.",
    "admin.home.save": "Salvează homepage",
    "admin.home.saving": "Se salvează…",
    "admin.home.saved": "Homepage salvat",
    "admin.home.undo": "Anulează modificările",
    "admin.home.unsaved": "Modificări nesalvate",
    "admin.home.open": "Deschide homepage",
    "admin.home.tagline.title": "Text pe fotografia hero",
    "admin.home.tagline.hint": "Apare peste fotografia din partea de sus a homepage-ului. Câte un câmp pentru fiecare limbă a site-ului — dacă RU sau EN sunt goale, se folosește textul în română; golește-le pe toate trei pentru a-l ascunde.",
    "admin.home.images.title": "Imagini homepage",
    "admin.home.images.hint": "Suprascrie imaginile principale de pe homepage. Dacă sunt goale, se folosesc cele implicite. Imaginile cardurilor de colecții vin din cover-ul fiecărei colecții — le editezi în tab-ul Categories.",
    "admin.home.images.hero": "Imagine hero (partea de sus)",
    "admin.home.images.experience": "Imaginea secțiunii \"Experiența Melilux\"",
    "admin.home.images.upload": "Încarcă imagine",
    "admin.home.images.uploading": "Se încarcă…",
    "admin.home.images.remove": "Elimină",
    "admin.home.images.fromProduct": "Alege din produse",
    "admin.home.images.pickProduct": "Alege un produs…",
    "admin.home.images.pickPhoto": "Apasă pe o fotografie pentru a o folosi",
    "admin.home.images.noImages": "Acest produs nu are fotografii.",
    "admin.about.images.title": "Imagini pagina Despre",
    "admin.about.images.hint": "Cele două fotografii de pe pagina \"Despre\". Dacă sunt goale, se folosesc cele implicite.",
    "admin.about.images.intro": "Imaginea secțiunii \"O familie de fabrici italiene\"",
    "admin.about.images.visit": "Imaginea secțiunii \"Doar cu programare\"",

    "admin.prod.title": "Gestionează piesele",
    "admin.prod.overline": "Catalog",
    "admin.prod.new": "Piesă nouă",
    "admin.prod.search": "Caută după nume sau descriere…",
    "admin.prod.filter.collections": "Toate colecțiile",
    "admin.prod.filter.styles": "Toate stilurile",
    "admin.prod.filter.statuses": "Toate statusurile",
    "admin.prod.filter.clear": "Șterge filtrele",
    "admin.prod.col.piece": "Piesă",
    "admin.prod.col.collection": "Colecție",
    "admin.prod.col.style": "Stil",
    "admin.prod.col.price": "Preț",
    "admin.prod.col.status": "Status",
    "admin.prod.col.featured": "Recomandat",
    "admin.prod.col.views": "Vizualizări",
    "admin.prod.col.actions": "Acțiuni",
    "admin.prod.empty": "Nicio piesă.",
    "admin.prod.onRequest": "la cerere",
    "admin.prod.perPage": "Pe pagină",
    "admin.prod.modal.new.overline": "Piesă nouă",
    "admin.prod.modal.new.title": "Adaugă în catalog.",
    "admin.prod.modal.edit.overline": "Editează piesa",
    "admin.prod.modal.edit.title": "Actualizează detaliile.",
    "admin.prod.field.name": "Nume",
    "admin.prod.field.description": "Descriere",
    "admin.prod.field.collection": "Colecție",
    "admin.prod.field.collection.placeholder": "Selectează o colecție",
    "admin.prod.field.collections": "Colecții",
    "admin.prod.field.collections.hint": "Selectează una sau mai multe — prima este colecția principală.",
    "admin.prod.field.collections.primary": "Principală",
    "admin.prod.field.status": "Status",
    "admin.prod.field.style": "Stil",
    "admin.prod.field.style.none": "— Niciuna —",
    "admin.prod.field.price": "Preț (opțional)",
    "admin.prod.field.salePrice": "Preț redus (opțional)",
    "admin.prod.field.salePercent": "Reducere % (opțional)",
    "admin.prod.field.room": "Cameră (opțional)",
    "admin.prod.field.dimensions": "Dimensiuni (opțional)",
    "admin.prod.field.materials": "Materiale (opțional)",
    "admin.prod.field.materials.placeholder": "Adaugă un material și apasă Enter",
    "admin.prod.field.materials.add": "Adaugă",
    "admin.prod.field.care": "Instrucțiuni de întreținere (opțional)",
    "admin.prod.field.images": "Imagini",
    "admin.prod.field.images.upload": "Încarcă imagini",
    "admin.prod.field.images.uploading": "Se încarcă…",
    "admin.prod.field.images.hint": "Se încarcă ca atare. Aceste fotografii întregi apar pe pagina produsului.",
    "admin.prod.field.card": "Imaginea cardului din colecții",
    "admin.prod.field.card.hint": "Miniatura 3:4 folosită în listări (Colecții, homepage). Treci cu mouse-ul peste o fotografie de mai sus și alege \"Decupează pentru card\". Pagina produsului arată mereu fotografia întreagă.",
    "admin.prod.field.card.use": "Decupează pentru card",
    "admin.prod.field.card.cropTitle": "Încadrează cardul din colecții.",
    "admin.prod.field.card.custom": "Decupare proprie",
    "admin.prod.field.card.auto": "Automat — prima fotografie, decupată centrat",
    "admin.prod.field.card.reset": "Înapoi la automat",
    "admin.prod.field.card.saved": "Imaginea cardului a fost actualizată — nu uita să salvezi",
    "admin.prod.field.featured": "Recomandat pe pagina principală",
    "admin.prod.field.featured.label": "Afișează această piesă pe pagina principală",
    "admin.prod.field.visible": "Vizibil în colecții",
    "admin.prod.field.visible.label": "Afișează această piesă în pagina publică de colecții",
    "admin.prod.field.currency": "Monedă",
    "admin.prod.cancel": "Anulează",
    "admin.prod.save": "Salvează modificările",
    "admin.prod.create": "Creează piesa",
    "admin.prod.saving": "Se salvează…",
    "admin.prod.delete.confirm": "Șterge \"{name}\"?",
    // Inquiries
    "admin.inq.title": "Solicitări",
    "admin.inq.overline": "Corespondență",
    "admin.inq.filter.all": "Toate",
    "admin.inq.filter.unread": "Necitite",
    "admin.inq.filter.product": "Produs",
    "admin.inq.filter.showroom": "Studio",
    "admin.inq.filter.general": "General",
    "admin.inq.empty": "Nicio solicitare.",
    "admin.inq.select.overline": "Selectează",
    "admin.inq.select.title": "Alege o solicitare pentru a citi.",
    "admin.inq.kind.showroom": "Vizită la studio",
    "admin.inq.kind.general": "Întrebare design",
    "admin.inq.kind.product": "Solicitare produs",
    "admin.inq.mail": "Email",
    "admin.inq.phone": "Telefon",
    "admin.inq.message": "Mesaj",
    "admin.inq.reply": "Răspunde prin email",
    "admin.inq.delete": "Șterge",
    "admin.inq.delete.confirm": "Ștergi această solicitare?",
    "admin.inq.received": "Primit",
    "admin.overview": "Prezentare generală",
    "admin.greeting": "Bună ziua,",
    "admin.curator": "curator.",
    "admin.kpi.pieces": "Piese în catalog",
    "admin.kpi.collections": "Colecții",
    "admin.kpi.inquiries": "Solicitări",
    "admin.kpi.visitors": "Vizitatori",
    "admin.kpi.unread": "Necitite",
    "admin.chart.byCollection": "Catalog pe colecții",
    "admin.chart.trend": "Solicitări · ultimele 7 zile",
    "admin.chart.topViewed": "Cele mai vizualizate piese",
    "admin.range.7d": "7 zile",
    "admin.range.30d": "30 de zile",
    "admin.range.all": "Total",
    "admin.chart.availability": "Mix disponibilitate",
    "admin.activity": "Activitate recentă",
    "admin.noData": "Fără date încă",
    "admin.noActivity": "Nicio activitate încă.",
    "admin.time.justNow": "acum",
    "admin.time.mAgo": "m în urmă",
    "admin.time.hAgo": "h în urmă",
};

const ADMIN_RU = {
    "admin.cat.title": "Управление коллекциями",
    "admin.cat.overline": "Коллекции",
    "admin.cat.new": "Новая коллекция",
    "admin.cat.col.collection": "Коллекция",
    "admin.cat.col.slug": "Slug",
    "admin.cat.col.products": "Изделия",
    "admin.cat.col.description": "Описание",
    "admin.cat.col.nav": "Нав",
    "admin.cat.col.actions": "Действия",
    "admin.delete.tip": "Удалить",
    "admin.delete.again": "Нажмите ещё раз для подтверждения",
    "admin.trash.title": "Корзина",
    "admin.trash.overline": "Недавно удалённые",
    "admin.trash.hint": "Элементы здесь автоматически удаляются через {days} дней.",
    "admin.trash.empty": "Корзина пуста.",
    "admin.trash.loading": "Загрузка…",
    "admin.trash.products": "Изделия",
    "admin.trash.categories": "Коллекции",
    "admin.trash.restore": "Восстановить",
    "admin.trash.deleteNow": "Удалить навсегда",
    "admin.trash.daysLeft": "осталось дней: {n}",
    "admin.trash.expiresToday": "Истекает сегодня",
    "admin.trash.restored": "Восстановлено",
    "admin.trash.purged": "Удалено навсегда",
    "admin.trash.moved": "Перемещено в корзину",
    "admin.cat.empty": "Нет коллекций.",
    "admin.cat.modal.new.overline": "Новая коллекция",
    "admin.cat.modal.new.title": "Определите новую комнату.",
    "admin.cat.modal.edit.overline": "Редактировать коллекцию",
    "admin.cat.modal.edit.title": "Уточните детали.",
    "admin.cat.field.name": "Название",
    "admin.cat.field.slug": "Slug (авто)",
    "admin.cat.field.parent": "Родительская коллекция (опц.)",
    "admin.cat.field.parent.none": "— Нет (верхний уровень) —",
    "admin.cat.field.description": "Описание",
    "admin.cat.field.cover": "Обложка",
    "admin.cat.field.cover.upload": "Загрузить изображение",
    "admin.cat.field.cover.uploading": "Загрузка…",
    "admin.cat.field.cover.url": "…или вставьте URL",
    "admin.cat.field.cover.fromProducts": "Выбрать из изделий",
    "admin.cat.picker.title": "Выберите изображение из изделия",
    "admin.cat.picker.use": "Использовать фото",
    "admin.cat.picker.step.collection": "Коллекции",
    "admin.cat.picker.searchCollections": "Поиск коллекций…",
    "admin.cat.picker.noProducts": "В этой коллекции нет изделий с изображениями.",
    "admin.cat.picker.search": "Поиск изделий…",
    "admin.cat.picker.empty": "Нет доступных изображений.",
    "admin.cat.picker.loading": "Загрузка…",
    "admin.cat.field.nav": "Показать в навигации",
    "admin.cat.field.nav.label": "Показывать эту коллекцию в публичной навигации",
    "admin.cat.cancel": "Отмена",
    "admin.cat.save": "Сохранить изменения",
    "admin.cat.create": "Создать",
    "admin.cat.saving": "Сохранение…",
    "admin.cat.delete.confirm": "Удалить \"{name}\"? Это действие необратимо.",
    "admin.cat.field.highlighted": "Выделение",
    "admin.cat.field.highlighted.label": "Показать как выделенную в панели фильтров",
    "admin.cat.col.highlighted": "Выделено",
    "admin.nav.console": "Консоль ателье",
    "admin.nav.overview": "Обзор",
    "admin.nav.homepage": "Главная",
    "admin.nav.categories": "Категории",
    "admin.nav.products": "Товары",
    "admin.nav.inquiries": "Запросы",
    "admin.nav.trash": "Корзина",
    "admin.nav.viewSite": "Открыть сайт",
    "admin.nav.darkMode": "Тёмная тема",
    "admin.nav.lightMode": "Светлая тема",
    "admin.nav.language": "Язык",
    "admin.nav.signedIn": "Вы вошли как",
    "admin.nav.signOut": "Выйти",

    "admin.home.leave.body": "У вас есть несохранённые изменения на главной. Что вы хотите сделать?",
    "admin.home.leave.saveGo": "Сохранить и выйти",
    "admin.home.leave.discard": "Уйти без сохранения",
    "admin.home.leave.stay": "Остаться на странице",

    "admin.home.overline": "Главная страница",
    "admin.home.title": "Настройка главной",
    "admin.home.featured.title": "Избранные изделия",
    "admin.home.featured.hint": "Выберите коллекцию, затем до 3 её товаров для секции \"Избранные изделия\". Порядок кликов = порядок показа. Если ничего не выбрано, автоматически показываются новейшие товары с отметкой featured.",
    "admin.home.featured.empty": "Товары не выбраны — на главной показываются товары с отметкой featured.",
    "admin.home.featured.max": "Максимум 3 товара.",
    "admin.home.gallery.title": "Галерея реализованных проектов",
    "admin.home.gallery.hint": "Выберите коллекцию, затем её товары для галереи \"Реализованные проекты\" на главной. Фотографии ведут на страницу товара. Порядок кликов = порядок показа.",
    "admin.home.gallery.category": "Исходная коллекция",
    "admin.home.gallery.pickCategory": "Выберите коллекцию…",
    "admin.home.gallery.empty": "Товары не выбраны — секция галереи скрыта на главной.",
    "admin.home.gallery.noProducts": "В этой коллекции нет товаров.",
    "admin.home.gallery.selectAll": "Выбрать все",
    "admin.home.gallery.clear": "Очистить выбор",
    "admin.home.gallery.selected": "Выбрано: {n}",
    "admin.home.gallery.max": "Максимум {n} товаров в галерее.",
    "admin.home.save": "Сохранить главную",
    "admin.home.saving": "Сохранение…",
    "admin.home.saved": "Главная сохранена",
    "admin.home.undo": "Отменить изменения",
    "admin.home.unsaved": "Несохранённые изменения",
    "admin.home.open": "Открыть главную",
    "admin.home.tagline.title": "Текст на главном фото",
    "admin.home.tagline.hint": "Отображается поверх фото в верхней части главной страницы. По одному полю на каждый язык сайта — если RU или EN пусты, используется румынский текст; очистите все три, чтобы скрыть его.",
    "admin.home.images.title": "Изображения главной",
    "admin.home.images.hint": "Замените основные изображения главной страницы. Если пусто — используются стандартные. Изображения карточек коллекций берутся из обложки каждой коллекции — редактируйте их во вкладке Categories.",
    "admin.home.images.hero": "Главное изображение (верх страницы)",
    "admin.home.images.experience": "Изображение секции \"Опыт Melilux\"",
    "admin.home.images.upload": "Загрузить изображение",
    "admin.home.images.uploading": "Загрузка…",
    "admin.home.images.remove": "Убрать",
    "admin.home.images.fromProduct": "Выбрать из товаров",
    "admin.home.images.pickProduct": "Выберите товар…",
    "admin.home.images.pickPhoto": "Нажмите на фото, чтобы использовать его",
    "admin.home.images.noImages": "У этого товара нет фотографий.",
    "admin.about.images.title": "Изображения страницы «О нас»",
    "admin.about.images.hint": "Две фотографии на странице «О нас». Если пусто — используются стандартные.",
    "admin.about.images.intro": "Изображение секции «Семья итальянских фабрик»",
    "admin.about.images.visit": "Изображение секции «По записи»",

    "admin.prod.title": "Управление изделиями",
    "admin.prod.overline": "Каталог",
    "admin.prod.new": "Новое изделие",
    "admin.prod.search": "Поиск по названию или описанию…",
    "admin.prod.filter.collections": "Все коллекции",
    "admin.prod.filter.styles": "Все стили",
    "admin.prod.filter.statuses": "Все статусы",
    "admin.prod.filter.clear": "Сбросить фильтры",
    "admin.prod.col.piece": "Изделие",
    "admin.prod.col.collection": "Коллекция",
    "admin.prod.col.style": "Стиль",
    "admin.prod.col.price": "Цена",
    "admin.prod.col.status": "Статус",
    "admin.prod.col.featured": "Рекомендуемое",
    "admin.prod.col.views": "Просмотры",
    "admin.prod.col.actions": "Действия",
    "admin.prod.empty": "Нет изделий.",
    "admin.prod.onRequest": "по запросу",
    "admin.prod.perPage": "На странице",
    "admin.prod.modal.new.overline": "Новое изделие",
    "admin.prod.modal.new.title": "Добавить в каталог.",
    "admin.prod.modal.edit.overline": "Редактировать изделие",
    "admin.prod.modal.edit.title": "Обновить детали.",
    "admin.prod.field.name": "Название",
    "admin.prod.field.description": "Описание",
    "admin.prod.field.collection": "Коллекция",
    "admin.prod.field.collection.placeholder": "Выберите коллекцию",
    "admin.prod.field.collections": "Коллекции",
    "admin.prod.field.collections.hint": "Выберите одну или несколько — первая является основной.",
    "admin.prod.field.collections.primary": "Основная",
    "admin.prod.field.status": "Статус",
    "admin.prod.field.style": "Стиль",
    "admin.prod.field.style.none": "— Нет —",
    "admin.prod.field.price": "Цена (опц.)",
    "admin.prod.field.salePrice": "Цена со скидкой (опц.)",
    "admin.prod.field.salePercent": "Скидка % (опц.)",
    "admin.prod.field.room": "Комната (опц.)",
    "admin.prod.field.dimensions": "Размеры (опц.)",
    "admin.prod.field.materials": "Материалы (опц.)",
    "admin.prod.field.materials.placeholder": "Добавьте материал и нажмите Enter",
    "admin.prod.field.materials.add": "Добавить",
    "admin.prod.field.care": "Уход (опц.)",
    "admin.prod.field.images": "Изображения",
    "admin.prod.field.images.upload": "Загрузить изображения",
    "admin.prod.field.images.uploading": "Загрузка…",
    "admin.prod.field.images.hint": "Загружаются как есть. Эти полные фото показываются на странице товара.",
    "admin.prod.field.card": "Изображение карточки в коллекциях",
    "admin.prod.field.card.hint": "Миниатюра 3:4 для списков (Коллекции, главная). Наведите на фото выше и выберите «Кадрировать для карточки». На странице товара всегда показывается полное фото.",
    "admin.prod.field.card.use": "Кадрировать для карточки",
    "admin.prod.field.card.cropTitle": "Кадрируйте карточку коллекции.",
    "admin.prod.field.card.custom": "Своё кадрирование",
    "admin.prod.field.card.auto": "Автоматически — первое фото, обрезка по центру",
    "admin.prod.field.card.reset": "Вернуть автоматически",
    "admin.prod.field.card.saved": "Изображение карточки обновлено — не забудьте сохранить",
    "admin.prod.field.featured": "Рекомендуемое на главной",
    "admin.prod.field.featured.label": "Показывать на главной странице",
    "admin.prod.field.visible": "Видимость в коллекциях",
    "admin.prod.field.visible.label": "Показывать на публичной странице коллекций",
    "admin.prod.field.currency": "Валюта",
    "admin.prod.cancel": "Отмена",
    "admin.prod.save": "Сохранить изменения",
    "admin.prod.create": "Создать изделие",
    "admin.prod.saving": "Сохранение…",
    "admin.prod.delete.confirm": "Удалить \"{name}\"?",
    "admin.inq.title": "Запросы",
    "admin.inq.overline": "Корреспонденция",
    "admin.inq.filter.all": "Все",
    "admin.inq.filter.unread": "Непрочитанные",
    "admin.inq.filter.product": "Продукт",
    "admin.inq.filter.showroom": "Студия",
    "admin.inq.filter.general": "Общие",
    "admin.inq.empty": "Нет запросов.",
    "admin.inq.select.overline": "Выберите",
    "admin.inq.select.title": "Выберите запрос для чтения.",
    "admin.inq.kind.showroom": "Визит в студию",
    "admin.inq.kind.general": "Вопрос по дизайну",
    "admin.inq.kind.product": "Запрос о продукте",
    "admin.inq.mail": "Email",
    "admin.inq.phone": "Телефон",
    "admin.inq.message": "Сообщение",
    "admin.inq.reply": "Ответить по email",
    "admin.inq.delete": "Удалить",
    "admin.inq.delete.confirm": "Удалить этот запрос?",
    "admin.inq.received": "Получено",
    "admin.overview": "Обзор ателье",
    "admin.greeting": "Добрый день,",
    "admin.curator": "куратор.",
    "admin.kpi.pieces": "Изделий в каталоге",
    "admin.kpi.collections": "Коллекции",
    "admin.kpi.inquiries": "Запросы",
    "admin.kpi.visitors": "Посетители",
    "admin.kpi.unread": "Непрочитанные",
    "admin.chart.byCollection": "Каталог по коллекциям",
    "admin.chart.trend": "Запросы · последние 7 дней",
    "admin.chart.topViewed": "Самые просматриваемые изделия",
    "admin.range.7d": "7 дней",
    "admin.range.30d": "30 дней",
    "admin.range.all": "За всё время",
    "admin.chart.availability": "Доступность",
    "admin.activity": "Последние действия",
    "admin.noData": "Нет данных",
    "admin.noActivity": "Нет активности.",
    "admin.time.justNow": "только что",
    "admin.time.mAgo": "м назад",
    "admin.time.hAgo": "ч назад",
};

export const MESSAGES = {
    ro: { ...COMMON_RO, ...ABOUT_RO, ...ADMIN_RO },
    ru: { ...COMMON_RU, ...ABOUT_RU, ...ADMIN_RU },
    en: { ...COMMON_EN, ...ABOUT_EN, ...ADMIN_EN },
};